export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9825.6458b9b2.jpg";